import React, { useState, useEffect } from 'react';
import ParentLogin from './ParentLogin';
import ParentDashboard from './ParentDashboard';
import { getStoredTheme, applyTheme } from './ParentThemeToggle';
import '../../parent-theme.css';

const TOKEN_KEY = 'ngs_parent_token';

function authHeader() {
  const t = localStorage.getItem(TOKEN_KEY);
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export default function ParentApp() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  // Apply persisted theme before first paint of parent UI
  useEffect(() => { applyTheme(getStoredTheme()); }, []);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) { setLoading(false); return; }
    fetch('/api/parent/auth/me', { headers: authHeader() })
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(u => { setUser(u); fetchDashboard(); })
      .catch(() => { localStorage.removeItem(TOKEN_KEY); setLoading(false); });
  }, []);

  const fetchDashboard = async () => {
    setDataLoading(true);
    try {
      const res = await fetch('/api/parent/dashboard', { headers: authHeader() });
      if (!res.ok) throw new Error();
      const d = await res.json();
      setData(d);
    } catch { /* handled by empty data state */ }
    finally { setDataLoading(false); setLoading(false); }
  };

  const handleLogin = (loginData) => {
    setUser(loginData.user);
    fetchDashboard();
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(null);
    setData(null);
  };

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', border: '3px solid rgba(200,90,26,0.2)', borderTopColor: '#C85A1A', animation: 'spin 0.7s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (!user) return <ParentLogin onLogin={handleLogin} />;

  return <ParentDashboard user={user} data={data} loading={dataLoading} onLogout={handleLogout} onRefresh={fetchDashboard} authHeader={authHeader} />;
}
